export default "__VITE_ASSET__AOyiCoeH__"